import { useContext, useState } from "react";
import axios from "axios";
import { Context } from "../context/Context";

const Calender = () => {
  const [loading, setLoading] = useState(false);

  const {
    //  auth,
      alreadyBooked, fetchBookedSlots, fetchMyPayments } =
    useContext(Context);

  //////////////////////////////////////////////////////////
  // CONVERT BOOKED SLOT FORMAT
  //////////////////////////////////////////////////////////

  const convertSlotsToObjects = (slots) => {
    const monthMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };

    return slots.map((slot) => {
      const parts = slot.split(" - ");

      const datePart = parts[0];
      const time = parts.slice(1).join(" - ");

      const [day, monthName, year] = datePart.split(" ");

      return {
        year: Number(year),
        month: monthMap[monthName],
        day: Number(day),
        time: time.trim(),
      };
    });
  };

  const alreadyBooked1 = convertSlotsToObjects(alreadyBooked);

  //////////////////////////////////////////////////////////
  // DATA
  //////////////////////////////////////////////////////////

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const times = [
    "1:00 PM - 1:30 PM",
    "1:30 PM - 2:00 PM",
    "5:00 PM - 5:30 PM",
    "5:30 PM - 6:00 PM",
  ];

  //////////////////////////////////////////////////////////
  // DATE STATE
  //////////////////////////////////////////////////////////

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    organization: "",
    phone: "",
    comment: "",
  });

  const amount = "Free";

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = new Date(year, month, 1).getDay();
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  //////////////////////////////////////////////////////////
  // MONTH NAVIGATION
  //////////////////////////////////////////////////////////

  const prevMonth = () => {
    const selectedDate = new Date(year, month, 1);
    const currentDate = new Date(currentYear, currentMonth, 1);

    if (selectedDate <= currentDate) return;

    setSelectedDay(null);
    setSelectedTime(null);

    if (month === 0) {
      setMonth(11);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };

  const nextMonth = () => {
    const maxBookingDate = new Date();
    maxBookingDate.setMonth(maxBookingDate.getMonth() + 3);

    const nextDate =
      month === 11 ? new Date(year + 1, 0, 1) : new Date(year, month + 1, 1);

    const limitDate = new Date(
      maxBookingDate.getFullYear(),
      maxBookingDate.getMonth(),
      1,
    );

    if (nextDate > limitDate) return;

    setSelectedDay(null);
    setSelectedTime(null);

    if (month === 11) {
      setMonth(0);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  //////////////////////////////////////////////////////////
  // BOOKING CHECK
  //////////////////////////////////////////////////////////

  const isBooked = (day, time) => {
    return alreadyBooked1.some(
      (b) =>
        Number(b.year) === Number(year) &&
        Number(b.month) === Number(month) &&
        Number(b.day) === Number(day) &&
        b.time?.trim() === time?.trim(),
    );
  };
  //////////////////////////////////////////////////////////
  // INPUT CHANGE
  //////////////////////////////////////////////////////////

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  //////////////////////////////////////////////////////////
  // BOOKING
  //////////////////////////////////////////////////////////

  const handleBook = async () => {
    if (loading) return;

    // if (!auth) {
    //   alert("Please login first");
    //   return;
    // }

    if (!selectedDay || !selectedTime) {
      alert("Select date & time");
      return;
    }

    if (
      !formData.fullName ||
      !formData.email ||
      !formData.organization ||
      !formData.phone
    ) {
      alert("Please fill all required fields");
      return;
    }

    if (isBooked(selectedDay, selectedTime)) {
      alert("Slot already booked");
      return;
    }

    const TimeandDate = `${selectedDay} ${months[month]} ${year} - ${selectedTime}`;

    try {
      setLoading(true);

      const { data } = await axios.post(
        "https://api.clinicalaiassistance.com/api/payment/checkout",
        {
          TimeandDate,
          ...formData,
        },
      );

      if (data.success) {
        await fetchBookedSlots();
        await fetchMyPayments();

        alert("🎉 Booking Confirmed!");

        setSelectedDay(null);
        setSelectedTime(null);

        setFormData({
          fullName: "",
          email: "",
          organization: "",
          phone: "",
          comment: "",
        });
      }
    } catch (error) {
      console.log(error.response?.data);

      alert(error.response?.data?.message || "Booking failed");
    } finally {
      setLoading(false);
    }
  };

  //////////////////////////////////////////////////////////
  // UI
  //////////////////////////////////////////////////////////

  return (
    <div
      id="section"
      className="min-h-screen flex items-center justify-center p-4 bg-gray-100 dark:bg-black dark:text-white"
    >
      <div className="w-full max-w-6xl bg-white dark:bg-[#0f0f0f] rounded-2xl shadow-xl overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[300px_1fr_320px]">
          {/* LEFT */}
          <div className="p-6 bg-gradient-to-b from-indigo-50 to-white dark:from-[#0f0f0f] dark:to-[#111]">
            <h2 className="text-lg font-semibold text-indigo-600">
              Clinical AI Assistance
            </h2>

            <h1 className="text-3xl mt-2 font-bold">Free Consultation</h1>

            <p className="text-gray-500 mt-1">30 minutes • {amount}</p>

            <div className="mt-6 p-4 rounded-xl bg-indigo-100 dark:bg-indigo-900/20 text-sm">
              <p className="font-medium">Timezone</p>
              <p className="text-gray-600 dark:text-gray-400">London/UK</p>
            </div>
          </div>

          {/* CALENDAR */}
          <div className="p-6 border-x">
            <div className="flex justify-between mb-4">
              <h2 className="font-semibold text-lg">
                {months[month]} {year}
              </h2>

              <div className="space-x-2">
                <button
                  onClick={prevMonth}
                  className="px-3 py-1 rounded bg-gray-200 dark:bg-[#1a1a1a]"
                >
                  {"<"}
                </button>

                <button
                  onClick={nextMonth}
                  className="px-3 py-1 rounded bg-gray-200 dark:bg-[#1a1a1a]"
                >
                  {">"}
                </button>
              </div>
            </div>

            <>
              <div className="grid grid-cols-7 gap-2 mb-3 text-center text-sm font-semibold text-gray-500">
                <div>Sun</div>
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
              </div>

              <div className="grid grid-cols-7 gap-2">
                {Array.from({ length: firstDay }).map((_, i) => (
                  <div key={i}></div>
                ))}

                {days.map((day) => {
                  const currentDateObj = new Date(year, month, day);

                  const weekDay = currentDateObj.getDay();

                  const isWeekend = weekDay === 0 || weekDay === 6;

                  const isPast =
                    year < currentYear ||
                    (year === currentYear && month < currentMonth) ||
                    (year === currentYear &&
                      month === currentMonth &&
                      day < currentDay);

                  const maxBookingDate = new Date();
                  maxBookingDate.setMonth(maxBookingDate.getMonth() + 3);

                  const isBeyondLimit = currentDateObj > maxBookingDate;

                  return (
                    <button
                      key={day}
                      disabled={isPast || isWeekend || isBeyondLimit}
                      onClick={() => {
                        if (isPast || isWeekend || isBeyondLimit) return;

                        setSelectedDay(day);
                        setSelectedTime(null);
                      }}
                      className={`aspect-square rounded-xl font-medium
          ${
            selectedDay === day
              ? "bg-indigo-600 text-white"
              : isPast || isWeekend || isBeyondLimit
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-gray-100 hover:bg-indigo-100 dark:bg-[#1a1a1a]"
          }`}
                    >
                      {day}
                    </button>
                  );
                })}
              </div>
            </>
          </div>

          {/* SLOT + FORM */}
          <div className="p-6">
            <h3 className="font-semibold text-lg">
              {selectedDay ? `${selectedDay} ${months[month]}` : "Select Date"}
            </h3>

            <div className="mt-4 space-y-3">
              {times.map((time) => {
                const booked = selectedDay && isBooked(selectedDay, time);

                return (
                  <button
                    key={time}
                    disabled={booked}
                    onClick={() => setSelectedTime(time)}
                    className={`w-full py-3 rounded-xl font-medium transition
                    ${
                      booked
                        ? "bg-red-100 text-red-600 cursor-not-allowed"
                        : selectedTime === time
                          ? "bg-indigo-600 text-white shadow-lg"
                          : "bg-gray-100 hover:bg-indigo-100 dark:bg-[#1a1a1a]"
                    }`}
                  >
                    {booked ? `${time} (Booked)` : time}
                  </button>
                );
              })}
            </div>

            {/* FORM */}
            {selectedDay && selectedTime && (
              <div className="mt-6 space-y-3">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full p-3 rounded-xl border dark:bg-[#1a1a1a]"
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email ID"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 rounded-xl border dark:bg-[#1a1a1a]"
                />

                <input
                  type="text"
                  name="organization"
                  placeholder="Organization"
                  value={formData.organization}
                  onChange={handleChange}
                  className="w-full p-3 rounded-xl border dark:bg-[#1a1a1a]"
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-3 rounded-xl border dark:bg-[#1a1a1a]"
                />

                <textarea
                  name="comment"
                  placeholder="Any Comment"
                  value={formData.comment}
                  onChange={handleChange}
                  rows={3}
                  className="w-full p-3 rounded-xl border dark:bg-[#1a1a1a]"
                />
              </div>
            )}

            <button
              onClick={handleBook}
              disabled={loading}
              className={`mt-6 w-full py-3 rounded-xl font-semibold shadow-lg transition flex items-center justify-center gap-2
              ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-indigo-600 hover:bg-indigo-700 text-white"
              }`}
            >
              {loading ? (
                <>
                  <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  Booking...
                </>
              ) : (
                "Book For Free"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calender;
